var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeTablesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "collaboration_1_",
    d: "M1.36,11.318V16H0.64v-4.683c0-2.221,1.342-4.163,3.347-4.969C3.242,5.749,2.79,4.834,2.79,3.85 c0-1.77,1.44-3.21,3.21-3.21s3.21,1.44,3.21,3.21c0,0.984-0.452,1.898-1.197,2.499c2.005,0.806,3.347,2.748,3.347,4.969V16h-0.72 v-4.683c0-2.16-1.467-4.016-3.566-4.514C6.924,6.768,6.813,6.64,6.799,6.487c-0.014-0.154,0.071-0.3,0.212-0.363 c0.899-0.4,1.48-1.293,1.48-2.275c0-1.373-1.117-2.49-2.49-2.49S3.51,2.477,3.51,3.85c0,0.982,0.581,1.875,1.48,2.275 c0.141,0.063,0.226,0.209,0.212,0.362C5.188,6.641,5.077,6.769,4.926,6.804C2.827,7.302,1.36,9.158,1.36,11.318z M28.014,21.349 c0.745-0.601,1.197-1.516,1.197-2.499c0-1.771-1.44-3.21-3.211-3.21s-3.211,1.439-3.211,3.21c0,0.983,0.452,1.898,1.197,2.499 c-2.005,0.806-3.347,2.748-3.347,4.969V31h0.721v-4.683c0-2.16,1.466-4.016,3.565-4.514c0.15-0.036,0.261-0.163,0.275-0.317 c0.015-0.153-0.071-0.3-0.212-0.362c-0.899-0.399-1.479-1.292-1.479-2.274c0-1.373,1.117-2.49,2.49-2.49s2.49,1.117,2.49,2.49 c0,0.982-0.58,1.875-1.479,2.274c-0.141,0.062-0.227,0.209-0.212,0.362c0.015,0.154,0.125,0.281,0.275,0.317 c2.1,0.498,3.565,2.354,3.565,4.514V31h0.721v-4.683C31.36,24.097,30.019,22.154,28.014,21.349z M6.36,23v-5.131l2.386,2.386 l0.509-0.51L6,16.491l-3.254,3.254l0.509,0.51l2.386-2.386V23c0,2.404,1.956,4.36,4.36,4.36h9v-0.72h-9 C7.993,26.64,6.36,25.007,6.36,23z M25.64,8v5.13l-2.385-2.385l-0.51,0.509L26,14.509l3.255-3.255l-0.51-0.509L26.36,13.13V8 c0-2.404-1.956-4.36-4.36-4.36H11v0.72h11C24.007,4.36,25.64,5.993,25.64,8z"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle",
    style: {
      fill: "none"
    },
    width: 32,
    height: 32
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeTablesIcon);
export default __webpack_public_path__ + "static/media/ChangeTablesIcon.c4e995b71fd2ebbfe59c7a013c311010.svg";
export { ForwardRef as ReactComponent };